import React, { useEffect, useState } from "react";
import Table from "../../../components/Table/Table";
import SideDrawer from "../../../components/SideDrawer/SideDrawer";
import GuardianParentsDetails from "./GuardianParentsDetails";
import { capitalizeWords, truncateText } from "../../../hooks/HelperFunctions";

const GuardianParents = ({ studentDetails }) => {
  const [parentsDetails, setParentDetails] = useState(false);
  const [parentsDetailsData, setParentDetailsData] = useState({});

  const [rows, setRows] = useState([]);
  const [showId, setshowId] = useState("");

  useEffect(() => {
    if (studentDetails?.gurdians) {
      setRows(convertCellToRowData(studentDetails?.gurdians));
    }
  }, [studentDetails]);

  const handleshowGardianDetails = (id, item) => {
    setshowId(id);
    setParentDetails(true);
    setParentDetailsData(item);
  };

  //===================== show data to the table =====================================//
  const headCells = [
    {
      id: "name",
      numeric: false,
      disablePadding: true,
      label: "Name",
      width: "20%",
      textAlign: "left",
    },
    {
      id: "calories",
      numeric: true,
      disablePadding: false,
      label: "ID",
      width: "10%",
      textAlign: "left",
    },
    {
      id: "fat",
      numeric: true,
      disablePadding: false,
      label: "Preferred contact",
      width: "30%",
      textAlign: "left",
    },
    {
      id: "carbs",
      numeric: true,
      disablePadding: false,
      label: "Relationship",
      width: "20%",
    },
    {
      id: "Details",
      numeric: true,
      disablePadding: false,
      label: "status",
      width: "15%",
    },
    {
      id: "Actions",
      numeric: true,
      disablePadding: false,
      label: "",
      width: "5%",
    },
  ];
  const renderStatusColor = (status) => {
    switch (status) {
      case "inactive":
        return {
          background: "#FCE7E9",
          color: "#E63946",
          linebackground: "#BA1A1A",
        };
      case "active":
        return {
          background: "#E1F2E8",
          color: "#0B9444",
          linebackground: "#41AB37",
        };
      case "invitation-pending":
        return {
          background: "#EDEDEF",
          color: "#676C7B",
          linebackground: "#979DAC ",
        };
      default:
        return { background: "", color: "", linebackground: "" };
    }
  };

  const convertCellToRowData = (arr) => {
    if (arr?.length > 0) {
      return arr?.map((item) => ({
        cell: [
          {
            text: item?.name
              ? capitalizeWords(truncateText(`${item?.name}`, 30))
              : "No Data",
          },
          { text: item?.userUniqueID ? item?.userUniqueID : "No Data" },
          { text: item?.email ? item?.email : "No Data" },
          {
            text: item?.relationShip
              ? capitalizeWords(item?.relationShip)
              : "No Data",
          },
          {
            Status: true,
            Padding: `0px !important`,
            background: renderStatusColor(item?.status).background,
            color: renderStatusColor(item?.status).color,
            linebackground: renderStatusColor(item?.status).linebackground,
            statusLine: true,
            label: item?.status ? capitalizeWords(item?.status) : "No Data",
          },
          {
            Button: true,
            buttonLabel: "Details",
            buttonTextcolor: "#5423FF",
            onClick: (e) => handleshowGardianDetails(item?.userUniqueID, item),
          },
        ],
      }));
    } else {
      return [];
    }
  };
  //===================== show data to the table =====================================//

  return (
    <div className="guardianTableContainer">
      <Table
        title="Guardian/Parents"
        tableHeader={true}
        addLabel="Create course"
        // icon={<AddIcon />}
        AddButton={false}
        headCells={headCells}
        rows={rows}
        // onClick={handleFilterDrawerOpen}
        footer={true}
        // handleSearchText={handleSearchText}
        // handleSearch={handleSearch}
        // setResetSearchTerm={setResetSearchTerm}
        // setSearchTerm={setSearchTerm}
        // resetsearchTerm={resetsearchTerm}
        innerHeader={true}
        showSearchBox={false}
        searchBoxPlaceholder="Search courses"
        // isDataLoading={isLoading || options?.isLoading}
        RowsPerPage={10}
        SearchBoxTop={false}
        emptyTableTitle="No course added yet"
        emptyTableNote="No items available"
        showButton={true}
        btnLabel="New Course"
        AddButtonInner={false}
        addLabelInner="Create course"
        InnerButtonColor="#0450E1"
        InnerButtonTextColor="#fff"
        // onClickEmptyCard={handleFilterDrawerOpen}
      />

      {/* ================================================ */}
      <SideDrawer
        open={parentsDetails}
        handleDrawerClose={() => setParentDetails(false)}
        title="Guardians/Parents Details"
        sideOpen="right"
        ButtonLabel="Close"
        cancelButtonLabel=""
        FooterWithoutTab={true}
        clickSaveButton={() => setParentDetails(false)}
        padding="0"
        body={
          <>
            <GuardianParentsDetails
              showId={showId}
              parentsDetailsData={parentsDetailsData}
            />
          </>
        }
      />
    </div>
  );
};

export default GuardianParents;
